import React, { useState } from "react";
import useStyles from "./styles";
import { BarChartProps } from "./types";
import { Bar } from "react-chartjs-2";
import {
  Card,
  CardHeader,
  Avatar,
  IconButton,
  CardContent,
  CircularProgress
} from "@material-ui/core";
import { Equalizer, ZoomIn } from "@material-ui/icons";

const BarChart = ({
  title,
  chartData,
  showLegend,
  options,
  isLoading
}: BarChartProps) => {
  const classes = useStyles();

  return (
    <Card>
      {title ? (
        <CardHeader
          title={title}
          className={classes.header}
          avatar={
            <Avatar aria-label={title} className={classes.avatar}>
              <Equalizer />
            </Avatar>
          }
          /*action={
                    <IconButton aria-label="zoom">
                      <ZoomIn/>
                    </IconButton>
                  }*/
        />
      ) : (
        <CardHeader />
      )}
      <CardContent className={classes.container}>
        <Bar
          type={Bar}
          data={() => {
            return {
              labels: chartData.labels,
              datasets: chartData.datasets.map(d => ({
                label: d.label,
                backgroundColor: `rgba(${d.rgbColor ? d.rgbColor.r : 5},${
                  d.rgbColor ? d.rgbColor.g : 89
                },${d.rgbColor ? d.rgbColor.b : 141}, 0.4)`,
                borderColor: `rgb(${d.rgbColor ? d.rgbColor.r : 5},${
                  d.rgbColor ? d.rgbColor.g : 89
                },${d.rgbColor ? d.rgbColor.b : 141})`, //"rgb(5,89,141)",
                maxBarThickness: 100,
                borderWidth: 1,
                borderRadius: 1,
                data: d.data,
                stack: d.stack
              }))
            };
          }}
          options={
            options
              ? options
              : !showLegend
              ? {
                  plugins: {
                    legend: {
                      display: false
                    }
                  },
                  tooltips: {
                    callbacks: {
                      label: function (tooltipItem: any) {
                        return tooltipItem.yLabel;
                      }
                    }
                  }
                }
              : ""
          }
        />
        {!isLoading ? (
          <></>
        ) : (
          <div className={classes.spinnerContainer}>
            <CircularProgress />
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default BarChart;
